export default "__VITE_ASSET__7616b515__"